<script>
import Message from "./Message.vue";
import moment from "moment";
import Status from "./Status.vue";
import Form from "vform";

export default {
    name: "RequestListItem",
    components: {Status, Message},
    props: ['request'],
    data: () => ({
        isLoading: false,
        opened: false,
        commentFields: {
            message: null,
            files: null
        },
        commentForm: new Form({}),
    }),
    computed: {
        description_fixed() {
            if (this.request.data.description.length > 150) {
                return this.request.data.description.slice(0, 147) + '...';
            } else {
                return this.request.data.description;
            }
        },
        created_at() {
            return moment(this.request.created_at).format('DD.MM.YYYY HH:mm');
        }
    },
    methods: {
        send() {
            let self = this;
            self.isLoading = true;
            self.commentForm = new Form({
                message: self.commentFields.message,
                files: self.commentFields.files,
            });
            self.commentForm.post('/api/servicedesk/' + this.request.id + '/addComment')
                .then(r => {
                    self.$emit('comment-added')
                    self.isLoading = false;
                    self.commentFields = {
                        message: null,
                        files: null
                    };
                    self.$message.success({
                        message: 'Комментарий добавлен',
                        duration: 2000,
                    });
                })
        },
        uploadFile(e) {
            this.commentFields.files = e.target.files;
        },
    }
}
</script>

<template>
    <div class="mb-4">
        <el-card shadow="hover" class="box-card">
            <div class="row">
                <div class="col-9">
                    <span class="text-muted">#{{ request.request_id }}</span> <Status class="d-inline" :status="request.data.status" /> <span v-if="request.viewed === 0" style="background-color: antiquewhite;color: #303133;" class="badge">Есть обновления</span>
                    <div>{{request.data.summary}}</div>
                </div>
                <div class="col-3">
                    <button v-if="opened === false" class="btn btn-light float-right" @click.prevent="opened = true">Подробнее</button>
                    <button v-if="opened === true" class="btn btn-light float-right" @click.prevent="opened = false">Свернуть</button>
                </div>
            </div>
            <div class="text-muted small">{{ created_at }}</div>
            <div v-if="opened">
                {{ request.data.description }}
                <template v-if="request.data.attachments && request.data.attachments.length">
                    <hr>
                    <div class="mt-3 mb-2 text-muted small" v-if="request.data.attachments">Файлы</div>
                    <span v-if="request.data.attachments" v-for="a in request.data.attachments" class="d-block">
                        <a :href="a.url" target="_blank"><span><i class="fas fa-download"></i> {{ a.file_name }}</span></a>
                    </span>
                </template>
                <template>
                    <hr>
                    <div class="mt-3 mb-2 text-muted small">{{request.data.comments.length ? 'Комментарии' : 'Нет комментариев'}}</div>
                    <Message :message="c" v-for="c in request.data.comments" :key="c.created_at" />
                    <template v-if="request.data.status !== 'Закрыта'">
                        <hr>
                        <form @submit.prevent="send" class="mt-3" v-loading="isLoading">
                            <div class="row">
                                <div class="col-9">
                                    <textarea rows="1" class=" form-control" placeholder="Комментарий" v-model="commentFields.message" required></textarea>
                                </div>
                                <div class="col-3"><button type="submit" class="btn btn-primary float-right">Отправить</button></div>
                                <div class="col-9 mt-2">
                                    <div class="custom-file">
                                        <input multiple type="file" name="files" class="custom-file-input" :id="'files' + _uid" lang="ru-RU" @change="uploadFile">
                                        <label class="custom-file-label" :for="'files' + _uid">{{commentFields.files ? 'Выбрано файлов: ' + commentFields.files.length : 'Выберите файлы'}}</label>
                                    </div>
                                    <has-error :form="commentForm" field="files"/>
                                </div>
                            </div>
                        </form>
                    </template>

                </template>
            </div>
        </el-card>
    </div>
</template>

<style scoped>

</style>